import { WordEditPage } from "@/features/learning-content/pages/WordEdit";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const WordEdit: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <WordEditPage />
      </Box>
    </Stack>
  );
};

export default WordEdit;
